const testimonials = [
  {
    name: "The Harrington Family",
    role: "Residents, Country Club East, Lakewood Ranch",
    highlight: "Daughter's school trip to London — passport expired 2 months before departure",
    story:
      "Our daughter attends Lakewood Ranch High School, and her honors history class organized a two-week educational tour to London, Paris, and Berlin over summer break. The school sent the passport requirement letter in January — six months before departure — and we promptly filed it away thinking we had plenty of time. Fast forward to May, three weeks before the trip, and the school sent a final reminder for passport copies. We pulled out Emily's passport and discovered it had expired in March. She was 15 when it was issued, so it was only valid for 5 years. We had completely forgotten. The trip was $4,800, non-refundable, and every hotel and train ticket was booked as a group. We called Fast Passport Center in complete panic. They walked us through the DS-11 process, arranged an acceptance appointment at the Bradenton post office the next morning, and processed Emily's new passport in six business days. She made the trip, saw the Tower of London and the Eiffel Tower, and came back with a journal full of stories. We now check all four family passports every January before the school year calendar is released. Never again.",
    rating: 5,
    tag: "School Trip",
  },
  {
    name: "James & Patricia M.",
    role: "Members, Lakewood Ranch Golf and Country Club",
    highlight: "St. Andrews golf pilgrimage — 72-hour emergency renewal for group trip",
    story:
      "I have been a member at Lakewood Ranch Golf and Country Club for twelve years, and every August our foursome takes a golf pilgrimage to Scotland. This year we had St. Andrews, Carnoustie, and Kingsbarns booked for ten days — the trip we had been talking about since last September. Two days before our flight from Tampa to Edinburgh, I pulled out my passport and realized it had expired six weeks ago. I have no idea how I missed it — I guess I had not used it since our trip to Portugal the previous summer. The other three guys were already packed. I was devastated. A fellow member at the club recommended Fast Passport Center, saying they had helped his wife with an emergency renewal for a cruise. I called them Tuesday afternoon, completely panicked. They arranged everything — the acceptance appointment, the emergency documentation, the courier handoff. My new passport arrived at my Lakewood Ranch home Thursday evening. I was on the flight Friday morning, teed off at St. Andrews Saturday afternoon, and played the Road Hole without a single thought about passports. These people saved a trip I had been planning for a year.",
    rating: 5,
    tag: "Golf Travel",
  },
  {
    name: "Sofia & Diego R.",
    role: "Polo Family, Winter Residents in Lakewood Ranch",
    highlight: "Emergency renewal for Buenos Aires polo season — 5-day turnaround",
    story:
      "We are from Buenos Aires originally, and our family has played polo for three generations. We winter in Lakewood Ranch because of the Sarasota Polo Club — the season runs December through April, and our children train here while we compete in local matches. Every November, we fly back to Argentina for the Argentine Open season at Palermo — the most important polo tournament in the world. This November, my husband discovered his passport had expired in August while we were deep in end-of-season activities here in Florida. Argentina requires six months of validity, and our flight was in twelve days. We have family waiting in Buenos Aires, horses stabled, and tournament invitations that took months to secure. Fast Passport Center understood immediately — they did not need an explanation of why a polo trip to Argentina was time-sensitive. They processed Diego's renewal in five business days, and we were at Palermo watching our nephew compete in the qualifying rounds on schedule. For families whose lives revolve around international sporting seasons, a passport delay is not an inconvenience — it is a crisis. They treated it like one and solved it.",
    rating: 5,
    tag: "Emergency",
  },
];

export default function LakewoodRanchTestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Lakewood Ranch Client Stories
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lakewood Ranch Travelers Say About Us
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>

              <div className="inline-block bg-[#F6C344]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full mb-4">
                {t.tag}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.story}&rdquo;
              </p>

              <div className="border-t border-gray-100 pt-4">
                <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                <div className="text-gray-500 text-xs">{t.role}</div>
              </div>

              <div className="mt-3 bg-[#1A365D]/5 rounded-md px-3 py-2">
                <p className="text-[#1A365D] text-xs font-semibold">{t.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}